import createClient from '@economic/http-client';
import { INTERNAL_API_APP_TOKEN_URL } from './internalApiClient';

export { createJsonPatchOperation } from '@economic/http-client';

export default createClient(process.env.ECONOMIC_OPENAPI_PATH, {
    url: INTERNAL_API_APP_TOKEN_URL,
    headerKey: 'Authorization',
    tokenName: 'Bearer ',
    tokenTimeout: 60,
});

export const externalOpenApiClient = createClient(process.env.ECONOMIC_OPENAPI_PATH);
